var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"width":"92%","max-height":"95%"},attrs:{"src":require("../../assets/img/homeBG.jpg")}})])}]

export { render, staticRenderFns }